import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useCurrentUserProfile = (options = {}) => {
  const context = useAuthContext('payroll_employee:edit');
  const { loading, data } = useQuery(Queries.GetMyProfiles, {
    context,
    ...options,
  });
  if (!data) return { loading, data };
  const profile = data.getCurrentUser.profiles[0];
  return { loading, data: profile };
};

export default useCurrentUserProfile;
